import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
  Jumbotron,
  Container,
  Row,
  Col,
  Button
} from 'reactstrap';
import { ResponsiveImage } from 'dabbl-react-components';

// Images
import {BACKGROUND_HOME_IMAGE, DOWNTIMEDOLLARS_LOGO} from "../../../../retailerValues";

class HomeJumbotron extends Component {

  static propTypes = {
    onBtnClick: PropTypes.func,
  }

  static defaultProps = {
    onBtnClick: () => {},
  }

  render() {
    const { onBtnClick } = this.props;

    return (
      <div>
        <Jumbotron
          className="Jumbotron"
          style={{backgroundImage: "url(" + BACKGROUND_HOME_IMAGE + ")"}}
          fluid
        >
          <div className="Jumbotron_backgroundOverlay"></div>

          <Container>
            <Row>
              <Col xs={12} sm={6}>

                  {/* Logo */}
                  <ResponsiveImage
                    className="Jumbotron_logo"
                    src={DOWNTIMEDOLLARS_LOGO}
                    alt="Downtime Dollars Logo"
                    aspectRatio={false}
                  />

                  {/* Text */}
                  <div>
                    <h1 className="Jumbotron_title">
                      Turn Your Downtime into Dollars!
                    </h1>
                    <h5 className="Jumbotron_subtitle thin-font">
                      Have fun with your favorite brands while saving money on your groceries
                    </h5>

                    <Button
                      className="Jumbotron_btn"
                      color="primary"
                      onClick={onBtnClick}
                    >
                      Get Started
                    </Button>
                  </div>

              </Col>
            </Row>
          </Container>
        </Jumbotron>
      </div>
    );
  }
}

export default HomeJumbotron;


// const HomeJumbotron = ({ onBtnClick }) => {
//   return (
//     <Jumbotron className="HomePage_jumbotron">
//       <Container>
//         {/* Downtime Dollars */}
//         <Row>
//           <Col xs={12}>
//             <p className="HomePage_jumbotron_topBar">
//               Downtime Dollars
//             </p>
//           </Col>
//         </Row>
//
//         <Row>
//           {/* Text */}
//           <Col xs={12} md={6}>
//             <div className="HomePage_jumbotron_textContainer">
//               <h1>Turn Your Downtime Into Dollars!</h1>
//               <h4 className="HomePage_jumbotron_subtitle">
//                 Have fun with your favorite brands while
//                 saving money on your groceries
//               </h4>
//               <button
//                 onClick={onBtnClick}
//                 className="HomePage_btn-getStarted"
//                 type="button"
//               >
//                 Get Started
//               </button>
//             </div>
//           </Col>
//
//           {/* Image */}
//           <Col xs={12} md={6} className="HomePage_jumbotron_imgContainer">
//             <img
//               className="HomePage_jumbotron_img"
//               src={jumbotronImage}
//               alt="ShopRite mobile and desktop examples"
//             />
//           </Col>
//         </Row>
//
//       </Container>
//
//     </Jumbotron>
//   );
// }
//
// HomeJumbotron.defaultProps = {
//   onBtnClick: () => {}
// }



// WEBPACK FOOTER //
// ./src/pages/Home/components/Jumbotron/Jumbotron.js